import { Component, OnInit, Input } from '@angular/core';
import { TableColumn } from '../../../models/tables/TableColumn';
import { COLUMN_TYPES } from '../../../contants/COLUMN_TYPES';
import { Router } from '@angular/router';

@Component({
	selector: 'simple-table',
	templateUrl: './simple-table.component.html',
	styleUrls: ['./simple-table.component.css']
})
export class SimpleTableComponent implements OnInit {

	@Input() columns: TableColumn[]; //columns for table
	@Input() data: any[]; //rows or data for table
	@Input() viewUrl: string = null;
	@Input() viewIdProp: string = null;

	constructor(private _router: Router) { }

	ngOnInit() {
	}


	getDisplayValue(rowData: any, column: TableColumn){
		if(column.dataType == COLUMN_TYPES.container){
			return;
		}

		if(column.dataType == COLUMN_TYPES.date){
			return;
		}

		if(column.dataType == COLUMN_TYPES.bool){
			return;
		}
		
		let value = rowData[column.name]
		if(value == undefined){
			return;
		}

		if(column.dataType == COLUMN_TYPES.select){
			let index = column.selectOptions.findIndex(x => x.key = value);
			return column.selectOptions[index].value;
		}

		return value;
	}

	goTo(dataId: number){
		if(this.viewUrl == null || this.viewIdProp == null)
			return;
		
		this._router.navigate([this.viewUrl, dataId]);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/simple-table/simple-table.component.ts